import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants/queryKeys';
import { callPublicAPI } from '../utils/api';
import { PartnerDetail } from '../types/types.ts';

export const useFetchRecommendedPartners = () => {
  return useQuery<PartnerDetail[]>({
    queryKey: [QUERY_KEYS.GET_RECOMMENDED_PARTNERS],
    queryFn: async () => {
      const searchParams = new URLSearchParams({
        favorite: '1',
        activeFor: '1000',
        limit: '1000'
      });

      const response = await callPublicAPI<PartnerDetail[]>('GET', '/partners', searchParams);
      return response.data;
    }
  });
};
